<!-- footer.component.html -->
<!-- <footer
  class="bg-footer text-white font-light text-center p-4 dark:bg-dark-footer dark:border-gray-900 dark:border-t"
>
  <span>
    Developed by PavCon, LLC. &#169; <b>{{ year }}</b
    >.
  </span>
  <span> All Rights Reserved </span>
  <span class="font-semibold">{{ version }}</span>
</footer> -->
<div class="footer no-print bg-black text-white pt-2 text-xs">
  <span>
    Developed by PavCon, LLC. &#169; {{ year }}. All Rights Reserved |
    {{ version }}</span>
</div>
<div class="footer print">
  <div class="distribution-statement text-xs text-balance">
    Distribution Statement D. Distribution authorized to Department of Defense and U.S. DoD
    contractors only.
    PavCon, LLC. All rights reserved. &copy; {{year}}.
    WARNING: This file may contain export-controlled information.
  </div>
</div>